module.exports = __webpack_public_path__ + "static/media/2import-4.31765832.xlsx";